import axios from 'axios'

import { apiUrl } from '@/api/base.js'

export default {
    get_star_info (args) {
        return axios.get(`${apiUrl}v2/get_star_info/`, { params: args })
    },
}